import type {Split} from '@/modules/common/hooks';
import type {InferOutput} from 'valibot';

import {useMemo} from 'react';
import {is, nullable, object, string, number} from 'valibot';

import {useLocalSplit} from '@/modules/common/hooks';

const appPromotionSplitConfigSchema = nullable(
  object({
    ios: string(),
    android: string(),
    appearanceLimit: number(),
    reappearanceDelay: number(),
  })
);

type Treatment = 'off' | 'visible' | 'disguised';
type Config = InferOutput<typeof appPromotionSplitConfigSchema>;

export const useAppPromotionSplit = (): Split<Treatment, Config> => {
  const split = useLocalSplit<Treatment>('FFP_4129_app_promotion_layer');

  const config = is(appPromotionSplitConfigSchema, split.config)
    ? split.config
    : null;

  return useMemo(
    () => ({
      ...split,
      config,
    }),
    [split, config]
  );
};
